/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { ButtonLayoutStyles, ButtonLayoutVariantOptions } from './themes/ButtonLayoutStyles.css';
import { ButtonLayoutRedwoodTheme } from './themes/redwood/ButtonLayoutTheme';
import { useComponentTheme } from '#hooks/UNSAFE_useComponentTheme';

type ButtonLayoutProps = {
  /**
   * Specifies the children.
   */
  children: ComponentChildren;

  /**
   * Specifies the spacing bewteen content.
   * 'sm' spacing is recommended for button variants that don't have a background or border, for example borderless buttons.
   * 'lg' spacing is recommended for button variants that have a background or border, for example outlined or solid buttons.
   */
  spacing?: 'sm' | 'lg';
};
/**
 * Button layout lays out a set of controls, such as buttons and menu buttons.
 */
export const ButtonLayout = ({ children, spacing = 'lg' }: ButtonLayoutProps) => {
  const { classes } = useComponentTheme<ButtonLayoutVariantOptions, ButtonLayoutStyles>(
    ButtonLayoutRedwoodTheme,
    { spacing }
  );

  return <div class={classes}>{children}</div>;
};
